import { Component, OnInit, HostBinding } from '@angular/core';

@Component({
  selector: 'app-calibrations-layout',
  templateUrl: './calibrations-layout.component.html',
  styleUrls: ['./calibrations-layout.component.scss']
})
export class CalibrationsLayoutComponent {
  @HostBinding('class') hostClasses = 'has-navbar-fixed-top';
}
